import React from 'react';
import styled from 'styled-components';
import * as FaIcons from 'react-icons/fa';
import * as IoIcons from 'react-icons/io';

const navItems = [
  { title: 'Accueil', path: 'home', icon: <FaIcons.FaHome /> },
  { title: 'Appel', path: 'contacts', icon: <IoIcons.IoIosCall /> },
  { title: 'Messages', path: 'messages', icon: <FaIcons.FaEnvelope /> },
  { title: 'Photos', path: 'photos', icon: <FaIcons.FaPhotoVideo /> },
  { title: 'Compte', path: 'account', icon: <FaIcons.FaUser /> },
];

const Nav = styled.nav`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #15171c;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    z-index: 1000;
    padding-bottom: env(safe-area-inset-bottom);
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.5);
  }
`;

const NavItem = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ $active }) => ($active ? 'rgba(99, 44, 228, 0.15)' : 'transparent')};
  border: none;
  color: ${({ $active }) => ($active ? '#9d50bb' : '#888')};
  padding: 8px 4px;
  cursor: pointer;
  gap: 4px;
  min-height: 58px;
  transition: background 0.2s ease, color 0.2s ease;
  -webkit-tap-highlight-color: transparent;

  &:active {
    background: rgba(99, 44, 228, 0.3);
  }

  svg {
    font-size: 22px;
  }
`;

const NavLabel = styled.span`
  font-size: 11px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  letter-spacing: 0.2px;
`;

const BottomNavBar = ({ currentPage, setCurrentPage }) => {
  const activePath = currentPage === 'appels' ? 'contacts' : currentPage;

  return (
    <Nav>
      {navItems.map((item) => {
        const isActive = activePath === item.path;
        return (
          <NavItem
            key={item.path}
            $active={isActive}
            onClick={() => setCurrentPage(item.path)}
            aria-label={item.title}
          >
            {item.icon}
            <NavLabel $active={isActive}>{item.title}</NavLabel>
          </NavItem>
        );
      })}
    </Nav>
  );
};

export default BottomNavBar;
